__esModule: true


/** WEBPACK FOOTER **
 ** ../../@traceur/generated/TemplateParser/2
 **/